module.exports = __webpack_public_path__ + "fonts/effect-drug-m-c463da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-drug-m.svg
// module id = 744
// module chunks = 0